import PropTypes from 'prop-types'
import InputMask from 'react-input-mask'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import ErrorModal from '../application/ErrorModal'
import validator from '../../helpers/validator'
import { setAttribute } from '../../actions/registration'

class HomeStepTwo extends Component {
  constructor(props) {
    super(props)

    this.onNameChange = this.onNameChange.bind(this)
    this.onNameKeyDown = this.onNameKeyDown.bind(this)
    this.onEmailChange = this.onEmailChange.bind(this)
    this.onTelChange = this.onTelChange.bind(this)
    this.onCityChange = this.onCityChange.bind(this)
    this.onRGChange = this.onRGChange.bind(this)
    this.onFormSubmit = this.onFormSubmit.bind(this)

    this.state = {
      error: '',
    }
  }

  componentDidMount() {
    if (!this.props.startOk) {
      this.props.history.push('/')
    }
  }

  onNameChange(event) {
    this.props.setAttribute('name', event.currentTarget.value)
  }

  onNameKeyDown(event) {
    if (event.keyCode === 13) {
      if (this.props.registration.name.length > 0) {
        this.birthdayInput.input.focus()

        event.preventDefault()
      }
    }
  }

  onEmailChange(event) {
    this.props.setAttribute('email', event.currentTarget.value)
  }

  onTelChange(event) {
    this.props.setAttribute('telefone', event.currentTarget.value)
  }

  onCityChange(event) {
    this.props.setAttribute('cidade', event.currentTarget.value)
  }

  onRGChange(event) {
    this.props.setAttribute('rg', event.currentTarget.value)
  }

  onHoursSelect(id, event) {
    const item = this.props.registration.selectedActions.find((item) => {
      return item.id === id
    })

    const newItem = {
      ...item,
      doado: event.currentTarget.value,
      num_registro:'',
    }

    const index = this.props.registration.selectedActions.findIndex((item) => {
      return (item.id === id)
    })

    const selectedActions = this.props.registration.selectedActions

    this.props.setAttribute('selectedActions', [
      ...selectedActions.slice(0, index),
      newItem,
      ...selectedActions.slice(index + 1),
    ])
  }

  onFormSubmit(event) {
    event.preventDefault()
    if (!validator.validateRequired.isValueValid(this.props.registration.name)) {
      this.setState({
        error: 'Por favor, preecha seu nome!',
      })
      this.modal.show()
      return
    }
    if (!validator.validateFormatEmail.isValueValid(this.props.registration.email)) {
      this.setState({
        error: 'Por favor, informe um endereço de e-mail válido',
      })
      this.modal.show()
      return
    }
    if (!validator.validateRequired.isValueValid(this.props.registration.telefone)) {
      this.setState({
        error: 'Por favor, preecha seu numero de telefone!',
      })
      this.modal.show()
      return
    }
    if (!validator.validateRequired.isValueValid(this.props.registration.rg)) {
      this.setState({
        error: 'Por favor, preecha o seu RG!',
      })
      this.modal.show()
      return
    }
    if (!validator.validateRequired.isValueValid(this.props.registration.cidade)) {
      this.setState({
        error: 'Por favor, preecha o nome de sua Cidade!',
      })
      this.modal.show()
      return
    }


    const hoursValidate = this.props.registration.selectedActions.find((item) => {
      return item.doado === 0
    })

    if (hoursValidate) {
      this.setState({
        error: 'Por favor, selecione quantas horas gostaria de doar!',
      })
      this.modal.show()
      return
    }

    const stepThree = this.props.registration.selectedActions.find((item) => {
      return (typeof item.registro !== 'undefined' && item.registro !== null)
    })
    this.props.setAttribute('start-ok', true)
    if (stepThree){
      this.props.history.push('/step3')
    }else{
      this.props.history.push('/step4')
    }
  }

  onClickRemove(id){
    this.props.setAttribute('selectedActions',
      this.props.registration.selectedActions.filter((item) => {
        return id !== item.id
      })
    )
  }

  renderActions(item){
    return (
      <div key={item.id} className="produto-modal">
        <div className="row">
          <div className="col-xs-6">
            <div className="title">{item.nome}</div>
            <div className="remover">
              <button onClick={this.onClickRemove.bind(this, item.id)}> Remover </button>
            </div>
          </div>
          <div className="col-xs-6">
            <div className="quantidade">
              <form>
                <select
                  onChange={this.onHoursSelect.bind(this, item.id)}
                  value={item.doado}
                  >
                  <option value="0">Horas</option>
                  <option value="1">01</option>
                  <option value="2">02</option>
                  <option value="3">03</option>
                  <option value="4">04</option>
                  <option value="5">05</option>
                  <option value="6">06</option>
                  <option value="7">07</option>
                  <option value="8">08</option>
                  <option value="9">09</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                  <option value="13">13</option>
                  <option value="14">14</option>
                  <option value="15">15</option>
                  <option value="16">16</option>
                  <option value="17">17</option>
                  <option value="18">18</option>
                  <option value="19">19</option>
                  <option value="20">20</option>
                </select>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }

  getActions() {
    return this.props.registration.selectedActions.map(this.renderActions.bind(this))
  }

  backToStart(){
    this.props.history.push('/')
  }

  render() {
    return (
      <div>
        <div className="modal-header">
          <div className="container">
            <div className="img-voltar">
              <a onClick={this.backToStart.bind(this)}>
                <img src="images/voltar.png" alt="Voltar"/>
              </a>
            </div>
            <div className="sobre">Sobre você</div>
          </div>
        </div>

        <div className="modal-body">
          <div className="container">
            <div className="chamada-modal">
              <img className="bt-voltar-header" src="images/heart.png" alt="corazon"/>
              <p className="detalhe">Obrigado pela vontade de ajudar!</p>
              <p>Para que ela se realize, preencha as informações abaixo:</p>
            </div>
            <div className="form-validacao-itens">
              <label>
                <p>*Nome completo</p>
                <input
                  ref={(ref) => { this.nameInput = ref }}
                  id="name"
                  value={this.props.registration.name}
                  onChange={this.onNameChange}
                  onKeyDown={this.onNameKeyDown}
                  placeholder="Escreva seu nome"
                  type="text"
                />
              </label>
                <label>
                  <p>*E-mail</p>
                <input
                  id="email"
                  value={this.props.registration.email}
                  onChange={this.onEmailChange}
                  placeholder="Escreva seu e-mail"
                  type="email"
                />
              </label>
              <label>
                <p>*Telefone</p>
                <InputMask
                  ref={(ref) => { this.telefone = ref }}
                  id="telefone"
                  mask="(99) 9999-99999"
                  value={this.props.registration.telefone}
                  onChange={this.onTelChange}
                  placeholder="Escreva seu telefone"
                  type="text"
                />
              </label>
              <label>
                <p>*RG</p>
                <input
                  ref={(ref) => { this.rg = ref }}
                  id="rg"
                  value={this.props.registration.rg}
                  onChange={this.onRGChange}
                  placeholder="Escreva seu RG"
                  type="text"
                />
              </label>
              <label>
                <p>*Cidade</p>
                <input
                  id="cidade"
                  value={this.props.registration.cidade}
                  onChange={this.onCityChange}
                  placeholder="Escreva sua cidade"
                  type="cidade"
                />
              </label>
            </div>
            <div className="camposobrigatorios">* campos obrigatórios</div>

            <div className="itens-modal">
              <div className="title-itens-modal">Tempo que você pode oferecer</div>
              <div className="lista-produtos-modal">
              {this.getActions()}
              </div>
            </div>
            <div className="bt-fechar-tudo">
              <button className="bt fecharpedido" onClick={this.onFormSubmit}>Tudo ok! Vamos continuar</button>
            </div>
        </div>
      </div>
      <ErrorModal
        ref={(ref) => { this.modal = ref }}
        message={this.state.error}
      />
      </div>
    )
  }
}

HomeStepTwo.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  registration: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    telefone: PropTypes.string,
    city: PropTypes.string,
  }).isRequired,
  setAttribute: PropTypes.func.isRequired,
  startOk: PropTypes.bool.isRequired,
}

HomeStepTwo.defaultProps = {
  history: {
    push: () => { },
  },
}

const mapStateToProps = state => ({
  registration: state.registration,
  startOk: !!state.registration['start-ok'],
})

const mapDispatchToProps = {
  setAttribute,
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeStepTwo)



// WEBPACK FOOTER //
// ./src/components/home/StepTwo.js